module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"Modal":{"close":{"ariaLabel":"Zavřít"}}},"de":{"Modal":{"close":{"ariaLabel":"Schließen"}}},"sk":{"Modal":{"close":{"ariaLabel":"Zavrieť"}}}}')
  delete Component.options._Ctor
}
